import { render } from "./dikelolaMasyarakat.vue?vue&type=template&id=5161950e"
import script from "./dikelolaMasyarakat.vue?vue&type=script&lang=js"
export * from "./dikelolaMasyarakat.vue?vue&type=script&lang=js"

import "./dikelolaMasyarakat.vue?vue&type=style&index=0&id=5161950e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__